(() => {
  let pending = new WeakSet();
  const resuming = new WeakSet();
  window.addEventListener('pageshow', () => { pending = new WeakSet(); });

  function postcodeError(field, invalid) {
    const error = document.getElementById(field.getAttribute('aria-describedby'));
    if (error) error.hidden = !invalid;
    field.setAttribute('aria-invalid', String(invalid));
    field.classList.toggle('border-scheme-error', invalid);
    field.classList.toggle('border-scheme-text', !invalid);
  }

  // Delegation also covers the popup's Alpine templates and theme editor reloads.
  document.addEventListener('invalid', (event) => {
    if (event.target.matches('[data-newsletter-postcode]')) {
      postcodeError(event.target, true);
    }
  }, true);
  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-newsletter-postcode]')) {
      postcodeError(event.target, !event.target.validity.valid);
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('form[data-klaviyo-newsletter]') || resuming.has(form)) return;
    if (pending.has(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    // Respect submissions already cancelled by an earlier capture listener.
    if (event.defaultPrevented) return;
    if (!form.reportValidity()) {
      event.preventDefault();
      return;
    }
    const siteId = form.dataset.klaviyoSiteId.trim();
    const listId = form.dataset.klaviyoListId.trim();
    if (!siteId || !listId || !window.fetch || !window.AbortController || !form.requestSubmit) return;

    event.preventDefault();
    // Run before form-level CAPTCHA handlers; replay once Klaviyo has finished.
    event.stopImmediatePropagation();
    pending.add(form);
    const submitter = event.submitter;
    const controller = new AbortController();
    const attributes = { email: form.elements.namedItem('contact[email]').value.trim() };
    const firstName = form.elements.namedItem('contact[first_name]');
    const postcode = form.querySelector('[data-newsletter-postcode]');
    if (firstName && firstName.value.trim()) attributes.first_name = firstName.value.trim();
    if (postcode && postcode.value) {
      attributes.location = { country: 'Australia', zip: postcode.value };
      attributes.properties = { 'Newsletter postcode': postcode.value };
    }
    const payload = {
      data: {
        type: 'subscription',
        attributes: { profile: { data: { type: 'profile', attributes } } },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };
    let timer;
    try {
      const timeout = new Promise((resolve) => {
        timer = window.setTimeout(() => {
          controller.abort();
          resolve();
        }, 3000);
      });
      const send = (endpoint, body) => fetch(
        `https://a.klaviyo.com/client/${endpoint}/?company_id=${encodeURIComponent(siteId)}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-10-15' },
          body: JSON.stringify(body),
          signal: controller.signal
        }
      );
      const update = async () => {
        try {
          await send('subscriptions', payload);
        } catch (_) {
          // A profile update can still succeed if only subscriptions are blocked.
        }
        if (!controller.signal.aborted && (attributes.first_name || attributes.location)) {
          await send('profiles', { data: { type: 'profile', attributes } });
        }
      };
      await Promise.race([update(), timeout]);
    } catch (_) {
      // Klaviyo failures must never prevent the native Shopify signup.
    } finally {
      window.clearTimeout(timer);
      resuming.add(form);
      try {
        form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
      } finally {
        resuming.delete(form);
        pending.delete(form);
      }
    }
  }, true);
})();
